<div class="box" [style]="'background-color: ' + color"></div>{{ label }}
